import { Link } from 'gatsby';
import React from 'react';
import { useMenuItem } from '../../hooks/use-menu-item';
import { MenuItem } from '../../interfaces/menu-item';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useLocation } from 'react-use';
import { AnimatePresence, motion } from 'framer-motion';

interface NavItemProps {
  item: MenuItem;
}

const NavItem: React.FC<NavItemProps> = ({ item }) => {
  const url = useMenuItem(item);
  const location = useLocation();

  if (item.subitems?.length) {
    return (
      <>
        <DropdownMenu.Root>
          <DropdownMenu.Trigger asChild>
            <button
              type="button"
              className={`hidden lg:flex items-center space-x-1.5 u-nav-link ${
                location.pathname?.startsWith(item.externalUrl || '') &&
                'u-nav-link--active'
              }`}
            >
              <span>{item.label}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2.5}
                stroke="currentColor"
                className="w-3 h-3"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                />
              </svg>
            </button>
          </DropdownMenu.Trigger>

          <DropdownMenu.Portal className="z-50">
            <AnimatePresence>
              <DropdownMenu.Content asChild>
                <motion.div
                  initial={{ opacity: 0, y: 5 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0 }}
                  className="relative z-50 pt-3 pb-4 mt-2 space-y-2 overflow-hidden bg-white border rounded shadow-sm border-slate-100"
                >
                  <div className="absolute top-0 left-0 right-0 h-1 bg-primary" />
                  {item.subitems.map((subitem) => (
                    <DropdownMenu.Item key={subitem.label} asChild>
                      <Link
                        to={`${subitem.targetPage?.url}`}
                        className="block px-6 py-2 text-sm font-medium transition-colors focus:outline-none focus-visible:outline-none hover:bg-slate-50 focus:text-slate-900"
                      >
                        {subitem.label}
                      </Link>
                    </DropdownMenu.Item>
                  ))}
                </motion.div>
              </DropdownMenu.Content>
            </AnimatePresence>
          </DropdownMenu.Portal>
        </DropdownMenu.Root>

        <div className="lg:hidden u-nav-link hover:after:opacity-0 hover:before:opacity-0">
          {item.label}
        </div>
        <div className="px-5 py-3 -mx-5 bg-slate-50 lg:hidden border-y border-slate-100">
          {item.subitems.map((subitem) => (
            <Link
              key={subitem.label}
              to={`${subitem.targetPage?.url}`}
              className={`block px-4 py-3 font-medium transition-colors focus:outline-none focus-visible:outline-none hover:bg-slate-50 focus:text-slate-900 ${
                location.pathname?.startsWith(subitem.targetPage?.url || '') &&
                'text-primary'
              }`}
            >
              {subitem.label}
            </Link>
          ))}
        </div>
      </>
    );
  }

  return (
    <Link
      // className="inline-block px-2 py-1 text-sm font-medium transition rounded-sm text-slate-800 hover:text-primary focus:text-primary u-ring"
      className="u-nav-link"
      activeClassName="u-nav-link--active"
      partiallyActive
      to={url}
    >
      {item.label}
    </Link>
  );
};

export default NavItem;
